import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-3079b29c")

_pushScopeId("data-v-3079b29c")
const _hoisted_1 = { class: "bg-ff table-content" }
const _hoisted_2 = { class: "flex alignC top-button-group" }
const _hoisted_3 = /*#__PURE__*/_createVNode("span", { class: "c-60 mar-r-8 mar-l-16" }, "出单时间", -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("span", { class: "c-60 mar-r-8 mar-l-16" }, "保险公司", -1)
const _hoisted_5 = { class: "mar-t-16" }
const _hoisted_6 = { class: "c-red fw-bold" }
const _hoisted_7 = {
  class: "flex flexC button-group",
  style: {"justify-content":"center"}
}
const _hoisted_8 = /*#__PURE__*/_createVNode("span", { class: "c-red" }, "通过", -1)
const _hoisted_9 = /*#__PURE__*/_createVNode("span", { class: "c-ff" }, "不通过", -1)
const _hoisted_10 = { class: "dialog-footer" }
const _hoisted_11 = /*#__PURE__*/_createVNode("span", { class: "c-ff" }, "确认", -1)
const _hoisted_12 = /*#__PURE__*/_createTextVNode("取 消")
const _hoisted_13 = { class: "flex flexR mar-t-22" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_date_picker = _resolveComponent("el-date-picker")
  const _component_el_option = _resolveComponent("el-option")
  const _component_el_select = _resolveComponent("el-select")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_table = _resolveComponent("el-table")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_form = _resolveComponent("el-form")
  const _component_el_dialog = _resolveComponent("el-dialog")
  const _component_el_pagination = _resolveComponent("el-pagination")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_el_date_picker, {
        modelValue: _ctx.dateRange,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.dateRange = $event)),
        class: "mar-r-16",
        type: "daterange",
        align: "right",
        "unlink-panels": "",
        "range-separator": "-",
        "start-placeholder": "开始日期",
        "end-placeholder": "结束日期"
      }, null, 8, ["modelValue"]),
      _hoisted_4,
      _createVNode(_component_el_select, {
        class: "mar-r-16",
        style: {"width":"140px"},
        modelValue: _ctx.searchParams.company,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.searchParams.company = $event)),
        placeholder: "请选择",
        clearable: ""
      }, {
        default: _withId(() => [
          _createVNode(_component_el_option, {
            label: "平安保险",
            value: "平安保险"
          }),
          _createVNode(_component_el_option, {
            label: "太平洋保险",
            value: "太平洋保险"
          }),
          _createVNode(_component_el_option, {
            label: "人保财险",
            value: "人保财险"
          }),
          _createVNode(_component_el_option, {
            label: "阳光保险",
            value: "阳光保险"
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_el_input, {
        class: "mar-l-16 mar-r-18",
        modelValue: _ctx.searchParams.search,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.searchParams.search = $event)),
        placeholder: "车牌号码",
        "suffix-icon": "el-icon-search",
        style: {"width":"180px"}
      }, null, 8, ["modelValue"])
    ]),
    _createVNode("div", _hoisted_5, [
      _createVNode(_component_el_table, {
        data: _ctx.pagedData,
        stripe: "",
        style: {"width":"100%"},
        class: "table",
        "header-cell-style": _ctx.headClass
      }, {
        default: _withId(() => [
          _createVNode(_component_el_table_column, {
            label: "车牌号码",
            align: "center",
            "min-width": "110"
          }, {
            default: _withId((scope) => [
              _createTextVNode(_toDisplayString(scope.row.car_code), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            label: "品牌车型",
            align: "center",
            "min-width": "120"
          }, {
            default: _withId((scope) => [
              _createTextVNode(_toDisplayString(scope.row.brand), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            label: "车架号",
            align: "center",
            "min-width": "140"
          }, {
            default: _withId((scope) => [
              _createTextVNode(_toDisplayString(scope.row.vin), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            label: "保险公司",
            align: "center",
            "min-width": "100"
          }, {
            default: _withId((scope) => [
              _createTextVNode(_toDisplayString(scope.row.company), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            label: "商业险金额",
            align: "center",
            "min-width": "110"
          }, {
            default: _withId((scope) => [
              _createTextVNode("¥" + _toDisplayString(scope.row.commercial_amount.toLocaleString()), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            label: "交强险金额",
            align: "center",
            "min-width": "110"
          }, {
            default: _withId((scope) => [
              _createTextVNode("¥" + _toDisplayString(scope.row.ci_amount.toLocaleString()), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            label: "总保险合计",
            align: "center",
            "min-width": "110"
          }, {
            default: _withId((scope) => [
              _createVNode("span", _hoisted_6, "¥" + _toDisplayString(scope.row.total_amount.toLocaleString()), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            label: "出单员",
            align: "center",
            "min-width": "80"
          }, {
            default: _withId((scope) => [
              _createTextVNode(_toDisplayString(scope.row.issuer), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            label: "出单日期",
            align: "center",
            "min-width": "110"
          }, {
            default: _withId((scope) => [
              _createTextVNode(_toDisplayString(scope.row.issue_date), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            label: "保险到期",
            align: "center",
            "min-width": "110"
          }, {
            default: _withId((scope) => [
              _createTextVNode(_toDisplayString(scope.row.expire_date), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            label: "提供人",
            align: "center",
            "min-width": "80"
          }, {
            default: _withId((scope) => [
              _createTextVNode(_toDisplayString(scope.row.provider), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            label: "战败原因",
            align: "center",
            "min-width": "150"
          }, {
            default: _withId((scope) => [
              _createTextVNode(_toDisplayString(scope.row.defeat_reason), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            label: "备注",
            align: "center",
            "min-width": "150"
          }, {
            default: _withId((scope) => [
              _createTextVNode(_toDisplayString(scope.row.remark), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            label: "操作",
            align: "center",
            "min-width": "160",
            fixed: "right"
          }, {
            default: _withId((scope) => [
              _createVNode("div", _hoisted_7, [
                _createVNode(_component_el_button, {
                  class: "border-red mar-r-8",
                  onClick: ($event: any) => (_ctx.auditPass(scope.row))
                }, {
                  default: _withId(() => [
                    _hoisted_8
                  ]),
                  _: 2
                }, 1032, ["onClick"]),
                _createVNode(_component_el_button, {
                  class: "bg-red mar-r-8",
                  onClick: ($event: any) => (_ctx.auditReject(scope.row))
                }, {
                  default: _withId(() => [
                    _hoisted_9
                  ]),
                  _: 2
                }, 1032, ["onClick"])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["data", "header-cell-style"])
    ]),
    _createVNode(_component_el_dialog, {
      title: "审核不通过",
      modelValue: _ctx.auditForm.dialog_show,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.auditForm.dialog_show = $event)),
      center: "",
      width: 500
    }, {
      footer: _withId(() => [
        _createVNode("span", _hoisted_10, [
          _createVNode(_component_el_button, {
            class: "bg-red",
            onClick: _ctx.auditSubmit
          }, {
            default: _withId(() => [
              _hoisted_11
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_el_button, {
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.auditForm.dialog_show = false))
          }, {
            default: _withId(() => [
              _hoisted_12
            ]),
            _: 1
          })
        ])
      ]),
      default: _withId(() => [
        _createVNode(_component_el_form, {
          model: _ctx.auditForm,
          "label-width": "80px"
        }, {
          default: _withId(() => [
            _createVNode(_component_el_form_item, { label: "车牌" }, {
              default: _withId(() => [
                _createVNode("span", null, _toDisplayString(_ctx.auditForm.car_code), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "不通过原因",
              required: ""
            }, {
              default: _withId(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.auditForm.reason,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.auditForm.reason = $event)),
                  type: "textarea",
                  rows: 4,
                  placeholder: "请填写不通过原因"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode("div", _hoisted_13, [
      _createVNode(_component_el_pagination, {
        onSizeChange: _ctx.handleSizeChange,
        onCurrentChange: _ctx.handleCurrentChange,
        "current-page": _ctx.currentPage,
        "page-sizes": [10, 20, 50],
        "page-size": _ctx.pageSize,
        layout: "total, sizes, prev, pager, next, jumper",
        total: _ctx.mockData.length
      }, null, 8, ["onSizeChange", "onCurrentChange", "current-page", "page-size", "total"])
    ])
  ]))
})